import React from "react";
function Footer() {
  return (
    <footer className="container mx-auto py-1 fixed bottom-0 md:left-20 bg-white dark:bg-dark-mode">
      <p className="text-xs text-center text-dark-content dark:text-light-content w-full">
        Obrigado por passar aqui, Ass. {" "}
        <a
          className="text-gradient font-medium"
          href="https://www.linkedin.com/in/eduardo-gavronski-neto-7013731aa/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <span className="text-gradient font-medium">Eduardo Neto</span>
        </a>{" "}
      </p>
    </footer>
  );
}
export default Footer;
